export enum BaseImagePlaceholderEnum {
  BASE_DEFAULT_AVATAR_COMPANY = '/assets/images/default_avatar-company.svg',
  BASE_DEFAULT_AVATAR = '/assets/images/default_avatar.svg',
  BASE_DEFAULT_AUTO_AVATAR = 'assets-global/images/support-bot-stazzle.svg',
}
